export default {
    list: {
        load: 'TIMEZONE_LIST_LOAD',
        success: 'TIMEZONE_LIST_SUCCESS',
    },
};
